<template>
    <!-- 弹窗遮罩 -->
    <div class="lite_popup" v-show="show">
        <!-- 弹窗 -->
        <div class="lite_popup_box lite_popup_box_confirm_mysql">
            <!-- 标题栏 -->
            <div class="lite_popup_title">
                <!-- 标题 -->
                <span>Warning</span>
                <!-- 关闭图标 -->
                <div class="icon white-close dialog-close" @click="cancel"></div>
            </div>
            <!-- 内容 -->
            <div class="lite_popup_content">
                <div>If the target website files or databases already exist, this restore will overwrite the existing website files or databases. Do you want to continue?</div>
            </div>
            <div class="lite_popup_footer">
                <!-- 按钮 -->
                <button class="white" @click="cancel">Cancel</button>
                <button ref="okBtn" @keyup.esc="show = false" @keyup.enter="ok" @click="ok">Continue</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
        };
    },
    watch: {
        show(val) {
            if (val) {
                this.$nextTick(() => {
                    this.$refs.okBtn.focus();
                });
            }
        }
    },
    methods: {
        ok() {
            this.show = false
            this.$emit('ok');
        },
        cancel() {
            this.show = false
            this.$emit('cancel');
        },
    }
};
</script>

<style>
/* 弹窗宽度 */
.lite_popup_box.lite_popup_box_confirm_mysql {
    width: 620px;
}
/* 弹窗内容高度 */
.lite_popup_box.lite_popup_box_confirm_mysql .lite_popup_content {
    height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/lite_confirm_mysql.vue